import { useEffect } from 'react'
import { useStoreState } from '../model/hooks'

export function useTransactionFollow(txHash: string, acceptedFunc: () => void, revertedFunc: () => void) {
    const transaction = useStoreState((state) => state.transaction.getTransaction(txHash))

    useEffect(() => {
        if (transaction && (transaction.status === 'ACCEPTED_ON_L2' || transaction.status === 'ACCEPTED_ON_L1')) acceptedFunc()
        if (transaction && transaction.status === 'REVERTED') {
            revertedFunc()
        }
    }, [transaction])
}
